/**
 * メール送信ダイアログ
 */
export class SendMail {
    /** TO宛先 */
    to = ""
    /** CC宛先 */
    cc: string | null = null
    /** BCC宛先 */
    bcc: string | null = null
    /** REPLY TO */
    replyTo: string | null = null
    /** 件名 */
    subject = ""
    /** 本文 */
    content = ""
    /** 報告書送付モード 0:送付しない 1:請求書に添付 2:報告書のみ */
    reportFileSendMode = 0
    /* 以下、報告書送付モード指定がある時のみ使用 */
    /** 報告書添付時件名 */
    subjectReportFileAttach = ""
    /** 報告書添付時本文 */
    contentReportFileAttach = ""
    /** 報告書のみ時件名 */
    subjectReportFileOnly = ""
    /** 報告書のみ時本文 */
    contentReportFileOnly = ""
    /** 添付報告書番号 */
    reportNos: string[] = []

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<SendMail>) {
        Object.assign(this, init)
    }
    
    /**
     * 複製を作成する
     */
    clone() {
        return new SendMail(JSON.parse(JSON.stringify(this)));
    }
}
